var r = function(e) {
  return Object.freeze(e);
};
export {
  r as freeze
};
